"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openUrl = exports.isLargerThan1075 = exports.getBuild = exports.getIsQB = exports.getBrowser = void 0;
const url_1 = require("./url");
exports.getBrowser = () => (window.browser || {});
exports.getIsQB = () => { var _a; return (((_a = window.browser) === null || _a === void 0 ? void 0 : _a.env) || false); }; // 兼容低版本
exports.getBuild = () => { var _a, _b; return (((_b = (_a = window.browser) === null || _a === void 0 ? void 0 : _a.env) === null || _b === void 0 ? void 0 : _b.build) || 0); };
/**
 * QB版本是否大于10.7.5
 */
exports.isLargerThan1075 = () => exports.getBuild() >= 1075e3;
/**
 * 在QB中打开一个地址, 支持http/qb等协议
 */
exports.openUrl = (originUrl, params = {}, isNeedTBS = true, isNewWindow = false) => {
    const mtt = window.mtt || null;
    if (!originUrl)
        return Promise.reject('should need url to open');
    if (!mtt)
        return Promise.reject('should need run init first');
    let url = '';
    if (Object.keys(params).length > 0) {
        url = `${originUrl}&${url_1.joinParams(params)}`;
    }
    else {
        url = originUrl;
    }
    // 如果是在qb内直接通过api打开
    if (exports.getIsQB()) {
        if (exports.getBrowser().app.openUrl) {
            const options = {
                url,
                newWindow: isNewWindow,
            };
            const open = new Promise((resolve, reject) => {
                try {
                    exports.getBrowser().app.openUrl(() => { }, () => { }, options);
                    resolve({
                        code: 0,
                        msg: 'ok',
                    });
                }
                catch (err) {
                    reject(err);
                }
            });
            return open;
        }
        return Promise.reject('should add apiJs - browser.app.openUrl');
    }
    if (isNeedTBS) {
        // 如果是在qb外 则判断有没有安装
        mtt.qb.isInstall((isInstall) => {
            // 有安装的话 直接唤醒打开
            if (isInstall) {
                mtt.qb.openQb({
                    url,
                    ct: '11045',
                });
                return Promise.resolve({
                    code: 0,
                    msg: 'ok',
                });
            }
            // 没有安装的话 直接唤醒安装
            mtt.qb.download({
                appStore: 'https://itunes.apple.com/app/apple-store/id370139302?pt=69276&mt=8&ct=11045',
                androidUrl: 'http://mdc.html5.qq.com/package?channel_id=11045',
                downloadImageUrl: 'https://res.imtt.qq.com/tagapp/qblogo_android_512.png',
                success: () => { },
                error: () => { },
                process: () => { },
            });
        });
    }
};
